import { useEffect, useState } from "react";

function useHandleClickOutside(ref) {
  const [hasClickOutside, setHasClickOutside] = useState(false);
  useEffect(() => {
    const handleClickOutside = (event) => {
      // Check if click is inside a DatePicker calendar popup (rendered in portal)
      const isDatePickerClick = event.target.closest?.(
        ".react-datepicker-popper, .react-datepicker"
      );

      if (ref?.current && !ref?.current?.contains(event.target)) {
        // Don't treat DatePicker calendar clicks as outside clicks
        if (!isDatePickerClick) {
          setHasClickOutside(true);
        } else {
          setHasClickOutside(false);
        }
      } else {
        setHasClickOutside(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [ref]);

  return { hasClickOutside };
}

export default useHandleClickOutside;
